import { BdbEncryptService } from '@npm-bbta/bbog-cm-auth-lib';
import { BdbRequestService } from './bdb-request.service';
import { Injectable } from '@angular/core';
import { RequestInfo } from '../models/request-info.model';
import { ResponseFromFetch } from '../models/response-from-fetch.model';
import { environment } from '../../../environments/environment';
import DebitCardPassword from '../models/debit-card-password.model';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import {SandboxRequestService} from './sandbox/sandbox-request.service';
import {EventsService} from './bdb-event.service';
import {IBodyForDebitCardKey} from '../models/IBodyForDebitCardKey';
@Injectable()
export class PasswordsService {

  /* this value will be removed soon, but it has to be here to complain with legacy services*/
  public site = this.sessionStorageService.get(SessionStorageKeysEnum.SITE);
  constructor(
    private readonly bdbSessionStorageService: BdbSessionStrgService,
    private readonly bdbEncryptService: BdbEncryptService,
    private readonly bdbRequest: BdbRequestService,
    private readonly sessionStorageService: BdbSessionStrgService,
    private bdbEventsService: EventsService,
    private sandbox: SandboxRequestService
  ) { }

  public loginWithDebitCardPassword(debitCardPasswordModel: DebitCardPassword): Promise<ResponseFromFetch> {
    const encryptedDocumentNumber = this.bdbEncryptService.encrypt(debitCardPasswordModel.documentNumber);
    const encryptedDocumentType = this.bdbEncryptService.encrypt(debitCardPasswordModel.documentType);
    const encryptedPassword = this.bdbEncryptService.encrypt(debitCardPasswordModel.password);
    const versionUrl = 'v4';
    const cardNumber = debitCardPasswordModel.cardNumber;
    const debitCardPasswordURL =
      `${environment.authenticatorEndpoint}/authentication/debitcard/${cardNumber}/check-pin/${versionUrl}`;
    const debitCardPasswordRequestBody: RequestInfo = {
      body: {
        documentNumber: encryptedDocumentNumber,
        documentType: encryptedDocumentType,
        gRecaptchaResponse: debitCardPasswordModel.gRecaptchaResponse,
        pin: encryptedPassword,
        uuid: debitCardPasswordModel.uuid,
        verifyReCaptcha: encryptedDocumentNumber
      }
    };
    return this.bdbRequest.requestPostWithOldHeaders(debitCardPasswordURL, debitCardPasswordRequestBody);
  }

    async debitCardWithSandboxV3(debitCardPasswordModel: DebitCardPassword): Promise<ResponseFromFetch> {
        const documentNumber = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const documentTypeFromSessionStorage = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE);
        const documentType = documentTypeFromSessionStorage === 'C' ? 'CC' : documentTypeFromSessionStorage;
        const newHeaders = this.bdbRequest.getStandardizedHeadersForSandboxv3(documentType, documentNumber);
        const url = `${environment.sandboxV3Domain}/identity/v1/debit-card-key/validate`;
        const channelMappings = {
          "FMV": "FuerzaMovil",
          "MFZ": "Microfinanzas",
        };
        let chanell = newHeaders['X-Channel']
        if (channelMappings[chanell]) {
            newHeaders['X-Channel'] = channelMappings[chanell];
        }
        const channelBodyMappings = {
          "FMV": "Fuerza Movil",
        }
        const body = this.getBody(debitCardPasswordModel);
        const mappedChannel = channelBodyMappings[body.dataToReport.channel];
        if (mappedChannel) {
          body.dataToReport.channel = mappedChannel;
        }
        Object.assign(newHeaders, {'content-type': 'application/json'});
        delete newHeaders['Content-Type'];
        return await this.sandbox.requestPostSandbox(url, body, newHeaders, true);
    }

    getBody(debitCardPasswordModel: DebitCardPassword) {
        const dataToReport = this.bdbEventsService.getInfoDataToReport();
        // THIS CODE IS A FAST RESOLUTION DUE CONFLICTS WITH CHECK LEAKS, MUST BE REFACTOR AS SOON AS POSSIBLE
        const codeData = atob('YmluRGF0YQ==');
        return {
            [codeData]: debitCardPasswordModel.password,
            cardId: debitCardPasswordModel.cardNumber,
            dataToReport
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/passwords.service.ts